module.exports = __webpack_public_path__ + "static/media/lock.028d212c.svg";